import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { somertonConfig } from "./data";

export default function SomertonPage() {
  return <CityPageTemplate config={somertonConfig} />;
}